"use strict";

var injectTwitterScript = function injectTwitterScript() {
  function addJS(jsCode) {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.innerText = jsCode;
    document.getElementsByTagName("head")[0].appendChild(s);
  }

  addJS("\n    window.twttr = (function(d, s, id) {\n      var js,\n        fjs = d.getElementsByTagName(s)[0],\n        t = window.twttr || {};\n      if (d.getElementById(id)) return t;\n      js = d.createElement(s);\n      js.id = id;\n      js.src = \"https://platform.twitter.com/widgets.js\";\n      fjs.parentNode.insertBefore(js, fjs);\n      t._e = [];\n      t.ready = function(f) {\n        t._e.push(f);\n      };\n      return t;\n    })(document, \"script\", \"twitter-wjs\");\n  ");
};

var injectedTwitterScript = false;
var embedClasses = [".twitter-tweet", ".twitter-timeline", ".twitter-follow-button", ".twitter-share-button"].join(",");

exports.onRouteUpdate = function () {
  // If there's an embedded element, lazy-load the twitter script (if it hasn't
  // already been loaded), and then run the twitter load function.
  if (document.querySelector(embedClasses) !== null) {
    if (!injectedTwitterScript) {
      injectTwitterScript();
      injectedTwitterScript = true;
    }

    if (typeof twttr !== "undefined" && window.twttr.widgets && typeof window.twttr.widgets.load === "function") {
      window.twttr.widgets.load();
    }
  }
};